import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditPost = props => {
  const { postId } = props.params

  return (
    <Edit
// @ts-ignore
      title='Edit Post'
      fields={fields}
      apiPath={`admin/posts/${postId}`}
      successRedirectPath='/cms/posts'
      buildMenuItems={menuItems}
    />
  )
}

export default EditPost
